'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _ = require('../');

var _OneTwoThree = require('./OneTwoThree.css');

var _OneTwoThree2 = _interopRequireDefault(_OneTwoThree);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OneTwoThree = (_dec = (0, _reactCssModules2.default)(_OneTwoThree2.default, { allowMultiple: true }), _dec(_class = function (_Component) {
  (0, _inherits3.default)(OneTwoThree, _Component);

  function OneTwoThree() {
    (0, _classCallCheck3.default)(this, OneTwoThree);
    return (0, _possibleConstructorReturn3.default)(this, (OneTwoThree.__proto__ || (0, _getPrototypeOf2.default)(OneTwoThree)).apply(this, arguments));
  }

  (0, _createClass3.default)(OneTwoThree, [{
    key: 'render',
    value: function render() {
      var icon1 = require('../../../static/images/123-1.png');
      var icon2 = require('../../../static/images/123-2.png');
      var icon3 = require('../../../static/images/123-3.png');

      //
      return _react2.default.createElement(
        'div',
        { styleName: '_123-wrap' },
        _react2.default.createElement(
          _.ContainerDivs,
          null,
          _react2.default.createElement(
            'h2',
            null,
            'How retirement funds impact society'
          ),
          _react2.default.createElement(
            'div',
            { styleName: '_123-flex' },
            _react2.default.createElement(
              'div',
              { styleName: '_123-cell' },
              _react2.default.createElement(
                'div',
                { styleName: '_123-image' },
                _react2.default.createElement('img', {
                  src: icon1,
                  alt: 'Step 1'
                })
              ),
              _react2.default.createElement(
                'h3',
                { styleName: '_123-copy' },
                'Companies like ',
                _react2.default.createElement(
                  'b',
                  null,
                  'Amazon'
                ),
                ' and ',
                _react2.default.createElement(
                  'b',
                  null,
                  'Comcast'
                ),
                ' offer employees a corporate retirement plan, to help them save for the future.'
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: '_123-cell' },
              _react2.default.createElement(
                'div',
                { styleName: '_123-image' },
                _react2.default.createElement('img', {
                  src: icon2,
                  alt: 'Step 2'
                })
              ),
              _react2.default.createElement(
                'h3',
                { styleName: '_123-copy' },
                'Asset managers like ',
                _react2.default.createElement(
                  'b',
                  null,
                  'Vanguard'
                ),
                ' and ',
                _react2.default.createElement(
                  'b',
                  null,
                  'BlackRock'
                ),
                ' take that money and invest it in the stock market via mutual funds.'
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: '_123-cell' },
              _react2.default.createElement(
                'div',
                { styleName: '_123-image' },
                _react2.default.createElement('img', {
                  src: icon3,
                  alt: 'Step 3'
                })
              ),
              _react2.default.createElement(
                'h3',
                { styleName: '_123-copy' },
                'The money is invested in fossil fuel companies like ',
                _react2.default.createElement(
                  'b',
                  null,
                  'ExxonMobil'
                ),
                ', arms manufacturers like ',
                _react2.default.createElement(
                  'b',
                  null,
                  'Raytheon'
                ),
                ', and private prison operators like ',
                _react2.default.createElement(
                  'b',
                  null,
                  'CoreCivic'
                ),
                '.'
              )
            )
          )
        )
      );
    }
  }]);
  return OneTwoThree;
}(_react.Component)) || _class);
exports.default = OneTwoThree;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/OneTwoThree/OneTwoThree.js
// module id = 1390
// module chunks = 0